import React from 'react';

import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { Avatar } from 'uiToolkitV1/Avatar';
import { AvatarGroup } from 'uiToolkitV1/AvatarGroup';
import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const MAX_AVATARS = 3;

const EmpGroupAvatars = ({ employees = [] }) => {
  const loggedInEmployeeData = useSelector(selectLoggedInEmployeeData);
  const tooltipAllEmp = (
    <>
      {employees.map(({ name }) => (
        <TextBodyMedium color="inherit">{name}</TextBodyMedium>
      ))}
    </>
  );

  if (!employees.length) {
    return <TextBodyMedium>NA</TextBodyMedium>;
  }

  return (
    <Tooltip label={tooltipAllEmp}>
      <Box>
        <AvatarGroup max={MAX_AVATARS} size={24} spacing="4px">
          {employees?.map(({ name, imageUrl, uuid }) => (
            <Avatar
              name={name}
              src={imageUrl}
              border={uuid === loggedInEmployeeData.id ? '1px solid green !important' : ''}
            />
          ))}
        </AvatarGroup>
      </Box>
    </Tooltip>
  );
};

const employeesValueGetterCSV = (employees = []) => employees.map(({ name }) => name).join(', ');

export { EmpGroupAvatars, employeesValueGetterCSV };
